module.exports = __webpack_public_path__ + "static/media/Avenir-Light.e5dd868d.ttf";